// src/components/ListaFiltro.js
import React, { useState } from "react";

// Filtro em forma de ranking: cada opção mostra quantos registros tem e uma
// barra fina proporcional, então o filtro também conta onde está o volume.
// A primeira linha ("Todas") limpa o filtro. Só as maiores aparecem de
// início, para a lista de registros abaixo começar no alto da tela.
function ListaFiltro({ titulo, rotuloTodas, total, opcoes, selecionada, aoEscolher, visiveis = 5 }) {
  const [expandida, setExpandida] = useState(false);
  const maior = Math.max(1, ...opcoes.map((o) => o.total));
  const escondidas = opcoes.length - visiveis;
  // Recolher só vale a pena se esconder mais de uma; a selecionada nunca some.
  const recolhivel = escondidas > 1;
  const indiceSelecionada = opcoes.findIndex((o) => o.id === selecionada);
  const mostrarTodas = !recolhivel || expandida || indiceSelecionada >= visiveis;
  const linhas = [
    { id: "todos", nome: rotuloTodas, total, todas: true },
    ...(mostrarTodas ? opcoes : opcoes.slice(0, visiveis)),
  ];

  return (
    <section className="filtro" aria-label={titulo}>
      <h2 className="lateral-secao">{titulo}</h2>
      <ul className="filtro-lista">
        {linhas.map((opcao) => {
          const ativa = selecionada === opcao.id;
          return (
            <li key={opcao.id}>
              <button
                type="button"
                className={`filtro-item ${ativa ? "ativa" : ""}`}
                aria-pressed={ativa}
                onClick={() => aoEscolher(ativa && !opcao.todas ? "todos" : opcao.id)}
              >
                <span className="filtro-nome">{opcao.nome}</span>
                <span className="filtro-total num">{opcao.total}</span>
                {!opcao.todas && (
                  <span className="filtro-barra" style={{ "--proporcao": opcao.total / maior }} aria-hidden="true" />
                )}
              </button>
            </li>
          );
        })}
      </ul>
      {recolhivel && indiceSelecionada < visiveis && (
        <button type="button" className="filtro-mais" aria-expanded={expandida} onClick={() => setExpandida(!expandida)}>
          {expandida ? "Mostrar menos" : `Mostrar mais ${escondidas}`}
        </button>
      )}
    </section>
  );
}

export default ListaFiltro;
